// 报告内容管理（培哥补充0502）
// type: 1=管理建议, 2=成功案例, 3=推荐课程
// risk_level: 1=低风险, 2=中风险, 3=高风险, 0=全部适用

export const reportContentConfigs = [
  // 管理建议 type=1
  { content_id: 1, type: 1, title: '安排一对一沟通', content: '近期安排一次非正式的一对一沟通，了解员工的职业诉求和当前困惑，表达组织对其的重视。', risk_level: 2, sort_order: 1, status: 1 },
  { content_id: 2, type: 1, title: '梳理任务分配', content: '适当调整任务分配，给予更具挑战性的项目，避免长期重复性工作导致倦怠。', risk_level: 2, sort_order: 2, status: 1 },
  { content_id: 3, type: 1, title: '制定晋升路径', content: '与员工共同制定明确的晋升路径和时间表，给予可预期的成长空间和发展方向。', risk_level: 3, sort_order: 1, status: 1 },
  { content_id: 4, type: 1, title: '薪酬回顾', content: '启动薪酬回顾流程，确保其薪资处于市场中位数水平，消除薪酬倒挂带来的不满。', risk_level: 3, sort_order: 2, status: 1 },
  { content_id: 5, type: 1, title: '保持定期关注', content: '低风险员工保持良好的工作状态，建议继续保持定期沟通节奏，关注其长期发展意愿。', risk_level: 1, sort_order: 1, status: 1 },

  // 成功案例 type=2
  { content_id: 6, type: 2, title: '技术骨干因项目挑战而保留', content: '某技术骨干因长期做维护工作产生离职想法，主管为其争取到核心新项目的技术负责人角色，员工在项目中获得成就感并决定继续留任。', risk_level: 2, sort_order: 1, status: 1 },
  { content_id: 7, type: 2, title: '薪酬调整挽回核心人才', content: '某产品经理因薪酬低于市场水平提出离职，经薪酬回顾后调整到市场中上水平，并配套股权激励方案，最终成功挽留。', risk_level: 3, sort_order: 1, status: 1 },
  { content_id: 8, type: 2, title: '工作生活平衡改善', content: '某员工因长期加班和家庭照顾冲突考虑离职，主管协调调整工作节奏并允许部分远程办公，员工满意度显著提升。', risk_level: 2, sort_order: 2, status: 1 },

  // 推荐课程 type=3
  { content_id: 9, type: 3, title: '高绩效员工保留策略', content: '学习如何识别和保留团队中的高绩效人才，掌握关键人才的留任方法论。', risk_level: 0, sort_order: 1, status: 1 },
  { content_id: 10, type: 3, title: '一对一沟通技巧', content: '掌握深度倾听和有效反馈的沟通方法，建立与下属的信任关系。', risk_level: 0, sort_order: 2, status: 1 },
  { content_id: 11, type: 3, title: '员工职业发展辅导', content: '学习如何帮助员工制定职业发展计划，打通内部成长通道。', risk_level: 0, sort_order: 3, status: 1 },

  // 话术与FAQ type=4
  { content_id: 12, type: 4, title: '员工提出加薪请求，如何回应？', content: '首先感谢员工的坦诚沟通，表示理解其诉求。然后说明公司薪酬回顾的周期和流程，承诺在下次薪酬回顾时重点考虑。同时可以探讨除薪酬外的其他激励方式，如项目机会、培训资源等。', risk_level: 2, keywords: ['薪资偏低'], sort_order: 1, status: 1 },
  { content_id: 13, type: 4, title: '发现员工在更新简历，怎么办？', content: '不要直接质问或指责。可以选择合适的时机进行一次非正式的关怀对话，了解员工是否有职业发展上的困惑或诉求。重点倾听，避免防御性回应。根据了解到的情况，制定针对性的保留策略。', risk_level: 3, keywords: ['外部机会'], sort_order: 1, status: 1 },
  { content_id: 14, type: 4, title: '员工表示工作压力大，如何疏导？', content: '首先确认具体压力来源（工作量、 deadlines、角色冲突等）。与员工一起梳理当前任务优先级，探讨是否可以调整任务分配或增加资源支持。同时关注员工的工作生活平衡，必要时协调短期休假。', risk_level: 2, keywords: ['压力大', '工作量大'], sort_order: 2, status: 1 }
]

export function getStoreReportContents() {
  const s = require('../store').default
  return s.state.reportContentConfigs && s.state.reportContentConfigs.contents && s.state.reportContentConfigs.contents.length
    ? s.state.reportContentConfigs.contents
    : reportContentConfigs
}
